import { render, staticRenderFns } from "./LightningSolid.vue?vue&type=template&id=1155a2b8&"
import script from "./LightningSolid.vue?vue&type=script&lang=ts&"
export * from "./LightningSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports